import React, { Component } from 'react';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Button from '@material-ui/core/Button';
import { translate } from '../../i18n/customI18nProvider';
import { getChoices, request } from '../../util';
import config from '../../config';
import Swal from 'sweetalert2';
import {
    useRefresh,
} from 'react-admin';
import { MenuItem } from '@material-ui/core';
import UidReader from '../nfc/UidReader';
import { activateClients } from '../../services/client.service';
import { FormControl, InputLabel, Select, TextField } from '@mui/material';

const styles = {
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  paper: {
    backgroundColor: 'whitesmoke',
    borderRadius: '10px',
    padding: '20px',
    minWidth: '80vw',
    maxHeight: '90vh',
    overflowY: 'auto'
  },
};

class ClientImportManualClass extends Component {

    emptyForm = {
        selected_entrance: "",
        selected_age: "-1",
        amount: 0,
        wristbands: []
    }

    constructor(props) {
        super(props);

        this.state = {
            open: false,
            entrances: [],
            entrance_choices: [],
            age_choices: getChoices(config.entrance_ages),
            import_enabled: true,
            event_id: null,
            ...this.emptyForm
        }

        this.importClients = this.importClients.bind(this);
        this.onClick = props.onClick;
        this.uidReaderRef = React.createRef();
    }

    async componentDidMount() {

        try {
            let entrances = await request('/entrances/all', 'GET', null);
            entrances = entrances.filter(entrance => ((entrance.type === config.entrance_types.ENTRANCE.value) || (entrance.type === config.entrance_types.UNPAID.value)));
            this.setState({entrances: entrances});
            let entrance_choices = entrances.map(entrance => ({id: entrance._id, name: entrance.name}));
            this.setState({entrance_choices: entrance_choices, event_id: entrances.length > 0 ? entrances[0].event_id : null});
        } catch(e) {
            console.log(e.message)
        }

    }

    handleOpen = () => {
        this.setState({open: true});
    }

    handleClose = () => {
        this.setState({
            open: false
        });
        this.onClick()
    }

    handleWristbandsChange = async (currentWristbands) => {
        this.setState({ wristbands: currentWristbands });
    }

    async importClients() {
        const confirm_import = await Swal.fire({
            icon: 'warning',
            title: translate('custom.warning'),
            text: translate('custom.are_you_sure_you_want_to_import') + ' ' + this.state.wristbands.length + ' ' + translate('custom.wristbands') + '?',
            showCancelButton: true,
            confirmButtonText: translate('custom.validate'),
            cancelButtonText: translate('custom.cancel'),
            confirmButtonColor: config.baseColor
        });
        if (!confirm_import.isConfirmed) return;
        if(this.state.amount === "" || isNaN(Number(this.state.amount))) {
            Swal.fire({
                title: translate('custom.error'),
                text: translate('custom.enter_a_valid_amount'),
                icon: 'error',
                confirmButtonText: translate('custom.ok'),
                confirmButtonColor: config.baseColor
            });
            return;
        }
        if(!this.state.selected_entrance) {
            Swal.fire({
                title: translate('custom.error'),
                text: translate('custom.select_an_entrance'),
                icon: 'error',
                confirmButtonText: translate('custom.ok'),
                confirmButtonColor: config.baseColor
            });
            return;
        }

        if(this.state.wristbands.length === 0) {
            Swal.fire({
                title: translate('custom.error'),
                text: translate('custom.no_wristbands_scanned'),
                icon: 'error',
                confirmButtonText: translate('custom.ok'),
                confirmButtonColor: config.baseColor
            });
            return;
        }

        let entrance = this.state.entrances.find(entrance => entrance._id === this.state.selected_entrance);
        if(Number(this.state.amount) < Number(entrance.price)) {
            let c = await Swal.fire({
                icon: 'warning',
                title: translate('custom.amount_is_less_than_entrance_price'),
                text: translate('custom.are_you_sure_you_want_to_continue'),
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: translate('custom.yes'),
                cancelButtonText: translate('custom.no'),
                confirmButtonColor: config.baseColor
            });
            if(!c.isConfirmed)
                return;
        }

        let selected_age = this.state.selected_age;
        if(this.state.selected_age == "-1") selected_age = null;
        
        const inProgressSwal = Swal.fire({
            title: translate('custom.processing'),
            text: '0 %',
            allowOutsideClick: false,
            showCancelButton: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })
        
        try {
            let response = await activateClients(this.state.wristbands, this.state.selected_entrance, this.state.amount, selected_age);

            if(response.error) {
                inProgressSwal.close();
                Swal.fire({
                    title: translate('custom.error'),
                    text: response.error_code ? (convertMessageCodeToMessage(response.error_code)) : (response.error ? response.error : translate('custom.unknown_error')),
                    icon: 'error',
                    confirmButtonText: translate('custom.ok'),
                    confirmButtonColor: config.baseColor
                });
            } else {
                let success = response.activated_count;
                let skipped = response.warnings?.length || 0;
                let failure = response.errors?.length || 0;
                let import_id = response.import_id;
                await Swal.fire({
                    title: translate('custom.import_completed'),
                    html: translate('custom.success') + ": " + success + "<br>"  +
                            translate('custom.failure') + ": " + failure + "<br>" +
                            translate('custom.skipped') + ": " + skipped + "<br>" +
                            translate('custom.import_id') + ": " + import_id,
                    icon: 'success',
                    confirmButtonText: translate('custom.ok'),
                    confirmButtonColor: config.baseColor
                });
                if(success > 0) {
                    this.props.refresh();
                    this.setState({ ...this.emptyForm });
                    this.handleClose();
                }
            }
        } catch(e) {
            inProgressSwal.close();
            Swal.fire({
                title: translate('custom.error'),
                text: e.message ? e.message : translate('custom.unknown_error'),
                icon: 'error',
                confirmButtonText: translate('custom.ok'),
                confirmButtonColor: config.baseColor
            });
        }
    }

    render() {
        return (
            <div>                
                <MenuItem onClick={this.handleOpen}>
                    {translate('custom.import_client_manual')}
                </MenuItem>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    // className={classes.modal}
                    style={styles.modal}
                    open={this.state.open}
                    onClose={this.handleClose}
                    closeAfterTransition
                    disableEnforceFocus={true}
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={this.state.open}>
                        <div style={styles.paper}>
                            {this.state.entrance_choices.length > 0 && (
                                <FormControl fullWidth variant="outlined" style={{ marginBottom: 16 }}>
                                    <InputLabel>{translate('custom.entrance')}</InputLabel>
                                    <Select
                                        value={this.state.selected_entrance || ''}
                                        onChange={e => this.setState({ selected_entrance: e.target.value })}
                                        label={translate('custom.entrance')}
                                    >
                                        {this.state.entrance_choices.map(choice => (
                                            <MenuItem key={choice.id} value={choice.id}>
                                                {choice.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            )}
                            
                            <TextField
                                type="number"
                                label={translate('custom.amount')}
                                variant="outlined"
                                fullWidth
                                value={this.state.amount || ''}
                                onChange={e => this.setState({ amount: e.target.value })}
                                onWheel={e => e.target.blur()}
                                inputProps={{ step: 1, min: 0 }}
                                style={{ marginBottom: 16 }}
                            />

                            <FormControl fullWidth variant="outlined" style={{ marginBottom: 16 }}>
                                <InputLabel>{translate('custom.age')}</InputLabel>
                                <Select
                                    value={this.state.selected_age}
                                    onChange={e => this.setState({ selected_age: e.target.value })}
                                    label={translate('custom.age')}
                                >
                                    <MenuItem key="-1" value="-1">
                                        {translate('custom.no_age_selected')}
                                    </MenuItem>
                                    {this.state.age_choices.map(choice => (
                                        <MenuItem key={choice.id} value={choice.id}>
                                            {choice.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <div style={{ marginBottom: 16 }}>
                                <UidReader
                                    ref={this.uidReaderRef}
                                    onMounted={() => {
                                        this.uidReaderRef?.current?.setBaseWristbands(this.state.wristbands);
                                    }}
                                    onWristbandsChange={this.handleWristbandsChange}
                                />
                            </div>

                            <Button
                                color="primary"
                                variant="contained"
                                size="small"
                                fullWidth
                                disabled={!this.state.import_enabled}
                                onClick={this.importClients}
                            >
                                {translate('custom.import')}
                            </Button>
                        </div>
                    </Fade>
                </Modal>
            </div>
        );
    }

}

const ClientImportManual = (props) => {
    
    const refresh = useRefresh();
    return <ClientImportManualClass {...props} refresh={refresh} />
}
export default ClientImportManual;